import { render } from "./footer-acknowledgement.vue?vue&type=template&id=c28eca0c&scoped=true"
const script = {}

import "./footer-acknowledgement.vue?vue&type=style&index=0&id=c28eca0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28eca0c"]])

export default __exports__